import { render } from "./PartnerVendorDownload.vue?vue&type=template&id=0f3ffe14&scoped=true"
import script from "./PartnerVendorDownload.vue?vue&type=script&lang=js"
export * from "./PartnerVendorDownload.vue?vue&type=script&lang=js"

import "./PartnerVendorDownload.vue?vue&type=style&index=0&id=0f3ffe14&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3ffe14"]])

export default __exports__